import { useApp } from '@/app/AppContext'
import { Icon } from '@/components/Icon'
import { ErrorActions, SupportCode, useRequestedPath } from './errorParts'

/**
 * Отказ по правам при прямом переходе (ТЗ §3), вёрстка по Err403.dc.html.
 *
 * Показывается вместо экрана раздела: данные пользователь всё равно не получит —
 * сервер откажет, — но бесконечная загрузка с 403 в консоли выглядит как поломка,
 * а не как запрет.
 *
 * Из макета нет двух вещей, и обе — пробелы API, а не забывчивость: кнопки «Запросить
 * доступ» (у сервера нет заявки на доступ — форма, уходящая в никуда, хуже её отсутствия)
 * и строк «Доступно ролям» / «Выдаёт доступ» (ни одна ручка не отвечает, у каких ролей
 * есть право на раздел и кто его выдаёт).
 */
export function AccessDenied() {
  const { t, user } = useApp()
  const path = useRequestedPath()
  return (
    <div className="err-page">
      <div className="state-box err-box">
        <div className="state is-forbidden err-state" role="status">
          <span className="err-code" aria-hidden="true">403</span>
          <span className="state-kind">
            <Icon name="lock" size="xs" />
            {t('state.kind.forbidden')}
          </span>
          <h1 className="st err-title">{t('access.denied')}</h1>
          <p className="sd">{t('access.deniedHint')}</p>
          <dl className="kv kv-box err-kv">
            <dt>{t('err.requested')}</dt>
            <dd className="mono">{path}</dd>
            {user && user.roles.length > 0 && (
              <>
                <dt>{t('err.yourRoles')}</dt>
                <dd className="row-wrap" style={{ gap: '4px 6px' }}>
                  {user.roles.map((role) => (
                    <span key={role} className="badge">{role}</span>
                  ))}
                </dd>
              </>
            )}
          </dl>
          <ErrorActions primary />
          <span className="help">{t('err.403.tip')}</span>
          <SupportCode code={403} path={path} />
        </div>
      </div>
    </div>
  )
}
